import { replace } from "ramda";
import initializeSvelteApp from "common/initializeSvelteApp";
import App from "./App";

export function calendarInitilaizerFactory({ component, target }) {
  return initializeSvelteApp({
    component,
    target,
    props: (element) => {
      // var $calendar = document.getElementsByClassName("js-events-calendar")[0];
      // if (!$calendar) return;
      var currentDateString = element.getAttribute("data-current-date");
      var currentDate;
      var basePath = element.getAttribute("data-base-path");
      var url = replace("{id}", R.__, basePath);
      var parsedEvents = JSON.parse(element.getAttribute("data-events")) || [];
      var events = parsedEvents.reduce(function reducer(acc, cur) {
        acc[cur.date] = {
          date: new Date(cur.date),
          url: url(cur.id),
          bottomHint: cur.amount === 0 ? "sold" : undefined,
        };
        return acc;
      }, {});
      var selected = [];

      if (currentDateString) {
        selected.push(currentDateString);
        currentDate = new Date(currentDateString);
      } else if (parsedEvents.length > 0) {
        currentDate = new Date(parsedEvents[0].date);
      } else {
        currentDate = new Date();
      }

      return {
        events: events,
        selected: selected,
        date: currentDate,
        strings: {
          month: window.TC_LABELS.MONTH_NAMES,
          shortMonth: window.TC_LABELS.SHORT_MONTH_NAMES,
          shortDays: window.TC_LABELS.SHORT_DAY_NAMES,
          todayLabel: window.TC_LABELS.TODAY,
        },
      };
    },
  });
}

// Initialize default Calendars
calendarInitilaizerFactory({ component: App, target: ".js-events-calendar" });
